// extracted by mini-css-extract-plugin
module.exports = {"container":"Loader_container__ksV2r","loader":"Loader_loader__QTwGG"};